import {
  typedDoc,
  setDocument,
  serverTimestamp,
  type Timestamp,
} from '@/lib/firebase/firestore'
import type { ImageSlotDocument, OverlayConfig } from '@/types'
import type { MediaDocument } from '@/features/admin/services/admin.media.service'

async function assignSlot(
  slotKey: string,
  media: MediaDocument,
  focusX: number,
  focusY: number,
  overlay: OverlayConfig,
  userId: string
): Promise<void> {
  await setDocument(typedDoc<ImageSlotDocument>('imageSlots', slotKey), {
    slotKey,
    mediaId: media.id,
    mediaUrl: media.url,
    focusX,
    focusY,
    overlay,
    updatedAt: serverTimestamp() as unknown as Timestamp,
    updatedBy: userId,
  })
}

export const designerService = { assignSlot }
